<template>
  <div class="finance-content">
    <h2 >账号系统</h2>
  </div>
</template>

<script>
  export default {
    data () {
    }
  }
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/components/content/product/accountNum.vue